import React from 'react';
import { SaveStatus, SystemLink, SystemUser } from 'v1/components/shared';

import './PageHeader.scss';
import { ConnectedOwnerPicker } from '~/v4/pages/users/UserPicker.owner.connected';
import { systemUserClasses } from '~/v1/components/shared/byModel/User/SystemUser/systemUserPickerClasses';
import classnames from 'classnames';
import { HamburgerMenu } from 'v5/features/core/HamburgerMenu';
import { DockableHeader } from 'v5/patterns/sidebar/DockableLayout';
import { OverflowContainer } from 'v5/patterns/page-layout/OverflowContainer';

const PageHeader = ({ sticky = false, ...props }) => {
  const renderOwner = () => {
    const { user_id } = props.meta;

    if (user_id) {
      return (
        <div className="PageHeader-meta tailwind-root">
          <div className="PageHeader-meta-user">
            {props.onOwnerSelect ? (
              // todo disconnect: turn PageHeader into factory and create a new component with given configuration
              <ConnectedOwnerPicker
                onSelect={props.onOwnerSelect}
                tooltip={props.ownerTooltip}
              >
                <SystemUser
                  tabIndex={0}
                  id={user_id}
                  includeImage
                  className={systemUserClasses}
                />
              </ConnectedOwnerPicker>
            ) : (
              <SystemUser id={user_id} includeImage />
            )}
          </div>
        </div>
      );
    }
  };

  const renderTags = () => {
    const { tags = [] } = props.meta;

    if (!tags || tags.length === 0) {
      return null;
    }

    return (
      <div className="tailwind-root">
        <div className="flex px-[5px]">
          <OverflowContainer className="gap-1 w-full min-w-[300px]">
            {tags.map(tag => (
              <span
                key={tag.id}
                className="font-semibold text-sm whitespace-nowrap rounded bg-gray-200 py-[3px] px-[5px] text-gray-600"
              >
                {tag.tag}
              </span>
            ))}
          </OverflowContainer>
        </div>
      </div>
    );
  };

  const {
    backLink,
    //backLabel,
    title,
    //subtitle,
    meta,
    children,
    updatingStatus,
    onPanelClick,
    beta
  } = props;

  const renderHeaderInfoPanel = () => {
    const WrapperComponent = onPanelClick ? 'button' : 'div';

    return (
      <div className="tailwind-root">
        <WrapperComponent
          onClick={() => onPanelClick && onPanelClick()}
          className={classnames('py-1 min-w-0', {
            'border-none bg-transparent cursor-pointer rounded hover:bg-gray-100 focus:bg-gray-100 ':
              WrapperComponent === 'button',
            'bg-inherit cursor-default': WrapperComponent === 'div'
          })}
        >
          <div className="PageHeader-mainTitle-title">
            <h3 className="trunc" title={title}>
              {title}
              {beta && <span className="PageHeader-beta">Beta</span>}
            </h3>
            {updatingStatus && (
              <SaveStatus
                loading={updatingStatus.isUpdating}
                updated={updatingStatus.updated}
                errors={updatingStatus.errors}
              />
            )}
          </div>
          {meta && renderTags()}
        </WrapperComponent>
      </div>
    );
  };

  return (
    <DockableHeader>
      <div
        className={classnames('PageHeader', { 'PageHeader-sticky': sticky })}
      >
        <HamburgerMenu />
        <div className="PageHeader-title-section">
          <div className="PageHeader-mainTitle">
            {backLink && (
              <SystemLink to={backLink} className="btn btn-link btn-square">
                <img
                  src="/images/icon_arrow_right_gray.svg"
                  className="flip"
                  width="10px"
                  alt="Back"
                />
              </SystemLink>
            )}
            {renderHeaderInfoPanel()}
          </div>
        </div>
        {meta && renderOwner()}
        <div className="PageHeader-buttons text-right">{children}</div>
      </div>
    </DockableHeader>
  );
};

export default PageHeader;
